import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function LeagueRankBg({ rank }: { rank: number }): React.ReactElement {
  const { t } = useTranslation('leaderboard')
  const width = 43
  const height = 43
  const className = 'absolute min-w-8'
  switch (rank) {
    case 1:
      return (
        <ResponsiveImage
          alt={t('rank')}
          className={className}
          height={height}
          srcKey="gamification/badges/league/gold-round.svg"
          width={width}
        />
      )
    case 2:
      return (
        <ResponsiveImage
          alt={t('rank')}
          className={className}
          height={height}
          srcKey="gamification/badges/league/silver-round.svg"
          width={width}
        />
      )
    case 3:
      return (
        <ResponsiveImage
          alt={t('rank')}
          className={className}
          height={height}
          srcKey="gamification/badges/league/bronze-round.svg"
          width={width}
        />
      )
    default:
      return <></>
  }
}
